import { type ComponentType, lazy } from 'react';
import { NotFoundPage } from '@lingoda/fallbacks';
import { KameleoonFlagKey, useFeatureFlagValue } from '@lingoda/kameleoon';
import {
    type RouteConfigExtended,
    TabValue,
    studentGrammarTrainerLessonPath,
    studentGrammarTrainerTopicPath,
} from '@lingoda/router';
import { Loader } from '@lingoda/ui';

const LessonPage = lazy(() => import('./LessonPage/LessonPage'));
const TopicPage = lazy(() => import('./TopicPage/TopicPage'));

const withGrammarTrainerFlag = (Page: ComponentType) => {
    const GrammarTrainerRoute = () => {
        const flag = useFeatureFlagValue(KameleoonFlagKey.grammarTrainer);

        if (flag.isLoading) {
            // TODO: put some default loader we use for such cases
            return <Loader />;
        }

        return flag.isVariant ? <Page /> : <NotFoundPage />;
    };

    return GrammarTrainerRoute;
};

const config: RouteConfigExtended['config'] = {
    hideHeader: true,
    hideFooter: true,
    hideDixa: true,
    hideMobileBottomNavbar: true,
    hideNotifications: true,
    tab: TabValue.Practice,
};

export const grammarTrainerRoutes: RouteConfigExtended[] = [
    {
        exact: true,
        component: withGrammarTrainerFlag(LessonPage),
        path: studentGrammarTrainerLessonPath.raw,
        label: 'Grammar trainer',
        config,
    },
    {
        exact: true,
        component: withGrammarTrainerFlag(TopicPage),
        path: studentGrammarTrainerTopicPath.raw,
        label: 'Grammar trainer',
        config,
    },
];
